import { useMemo } from "react"

import { ReflagProvider } from "@reflag/react-sdk"

import { useMeQuery } from "lib/hooks/useMe"

/**
 * Mounts the Reflag client for the admin app. The context is derived from the
 * admin session, so login/logout changes the context and ReflagProvider
 * re-evaluates flags automatically — no manual client updates needed.
 */
export function AppReflagProvider({ children }: { children: React.ReactNode }) {
  const { me } = useMeQuery()

  const context = useMemo(
    () => ({
      // Reflag ignores a user object without an `id`, so only pass one when
      // logged in. `app` discriminates admin vs web in flag rules (shared app).
      user: me ? { id: me.id, email: me.email, app: "admin" } : undefined,
      // rdeID identifies the RDE instance for per-instance targeting.
      other: { rdeID: process.env.NEXT_PUBLIC_RDE_ID || "" },
    }),
    [me],
  )

  return (
    <ReflagProvider
      publishableKey={process.env.NEXT_PUBLIC_REFLAG_PUBLISHABLE_KEY!}
      context={context}
    >
      {children}
    </ReflagProvider>
  )
}
